import { useTranslation } from 'react-i18next';

const keys = [
  'klassStatus',
  'userStatus',
  'enrollmentStatus',
  'userTypes',
  'courseFormats',
  'dayOfWeek',
  'klassType',
  'studentType',
] as const;

export type TranslateKeys = (typeof keys)[number];

type TranslatesObj = Record<string, (value: string) => string>;

export function useFilterLabelTranslated() {
  const { t } = useTranslation('translation');

  const translates = keys.reduce<TranslatesObj>((acc, key) => {
    acc[key] = (value: string) => t(value, { keyPrefix: key });
    return acc;
  }, {});

  function translate(name: TranslateKeys, value: string) {
    if (!translates[name]) return '';
    return translates[name](value);
  }

  return { translate };
}
